;(function () {
  'use strict';

  /**
   * 前回コピーモーダル
   */
  var previousCopyModal = {

    // 上書き確認ダイアログ用に 押されたボタン情報を保持
    $copyDestId: "",
    $previousUrl: "",
    $pushedButton: "",

    /**
     * 初期化
     */
    init: function (options) {
      var self = this;
      var config = $.extend({
        dialog: '.ui-dialog--previous-copy',              // ダイアログのセレクタ
        sideMargen: 15,                                   // 左右の余白 [px]
        openButton: '.js-dialog--previous-copy__open',    // ダイアログの表示ボタン
        okButton: '.js-dialog--previous-copy__overwrite', // ダイアログの上書きボタン(OK)
        closeButton: '.js-dialog--previous-copy__close',  // ダイアログの非表示ボタン
      }, options);

      if ($('body.sp-viewport').length) {
        // sp版のモーダル設定
        $(config.dialog).dialog({
          autoOpen: false,
          draggable: false,
          resizable: false,
          modal: true,
          width: $(window).width() - (config.sideMargen * 2),
          position: {
            my: 'center',
            at: 'center',
            of: window
          },
          dialogClass: 'dialog-previous-copy',
          show: 'fade',
          hide: 'fast'
        });
      } else {
        // pc版のモーダル設定
        $(config.dialog).dialog({
          autoOpen: false,
          draggable: false,
          resizable: false,
          modal: true,
          width: 300,
          position: {
            my: 'center',
            at: 'center',
            of: window
          },
          dialogClass: 'dialog-previous-copy',
          show: 'fade',
          hide: 'fast'
        });
      }

      /**
       * 前回コピーボタンを押した
       */
      $(config.openButton).on('click', function () {
        self.$pushedButton = $(this);
        self.$copyDestId = self.$pushedButton.attr('data-copy-dest-id');
        self.$copyItemType = self.$pushedButton.attr('data-item-type');
        self.$previousUrl = self.$pushedButton.attr('data-previous-url');

        // 入力済みであれば、上書き確認
        if (self.isTextPresent()) {
          $(config.dialog).dialog('open');
        } else {
          self.copyFromPrevious();
        }

        return false;
      });

      /**
       * 上書き確認後、OKボタンを押した
       */
      $(config.okButton).on('click', function () {
        self.copyFromPrevious();
        $(config.dialog).dialog('close');
        return false;
      });

      /**
       * 上書き確認後、キャンセルボタンを押した
       */
      $(config.closeButton).on('click', function () {
        $(config.dialog).dialog('close');
        return false;
      });
    },

    isTextPresent: function () {
      var self = this;

      if($(self.$copyDestId).val().length > 0){
        return true;
      }

      var isTextPresent = false;
      if (self.$copyItemType == 'poll') {
        $('li.poll-form__choice-item').each(function( index, element ) {
          var choiceTexts = element.children[0].children;
          for (var k = 0; k < choiceTexts.length; k++) {
            if (choiceTexts[k].id.endsWith('_name')) {
              if ($('#'+choiceTexts[k].id).val().length > 0) {
                isTextPresent = true;
                return false;
              }
            }
          }
        });
      }

      return isTextPresent;
    },

    copyFromPrevious: function () {
      var self = this;
      if (self.$pushedButton.data('loading')) {
        return; // 処理中
      }
      self.$pushedButton.data('loading', true);
      $.getJSON(self.$previousUrl).done(function (json) {
        if (json.previous_value != null) {
          if (self.$copyItemType != 'poll') {
            const $el = $(self.$copyDestId);
            $el.val(json.previous_value);
            const nativeEl = $el[0];
            if (nativeEl) nativeEl.dispatchEvent(new Event('input', { bubbles: true }));
          } else {
            $('.poll-form__choice-item').remove();
            $(self.$copyDestId).val(json.previous_value.poll_title);

            for(var i=0; i < json.previous_value.choices.length; i++){
              var itemId = self.$pushedButton.attr('data-item-id');
              var regexp = new RegExp(self.$pushedButton.attr('data-object-id'), 'g');
              var $container = $('.accepts-nested-attributes-for-field[data-item-id=' + itemId + ']');
              var $list = $container.find('.poll-form__choice-list');
              var $choice = self.$pushedButton.attr('data-fields').replace(regexp, i);
              $list.append('<li class="poll-form__choice-item">' + $choice + '</li>');
            }

            $('li.poll-form__choice-item').each(function( index, element ) {
              var choiceTexts = element.children[0].children;
              Object.keys(choiceTexts).forEach(function (key) {
                if (choiceTexts[key].id.endsWith('_name')) {
                  $('#'+choiceTexts[key].id).val(json.previous_value.choices[index].choice_name);
                }
              });
            });
          }
        }
        self.$pushedButton.data('loading', false);
      });
    }
  };

  /**
   * DOM content loaded
   */
  $(function () {
    previousCopyModal.init();
  });
}.call(this));
